/** Legacy iframe chart HTML stored definitions as chartdef_<hex> + lastChartDefinitionId */
const LEGACY_CHART_DEFINITION_COOKIE_RE = /^chartdef_[0-9a-f]+$/i

function isLegacyChartDefinitionCookieName(name: string): boolean {
  return name === 'lastChartDefinitionId' || LEGACY_CHART_DEFINITION_COOKIE_RE.test(name)
}

/**
 * Expires cookies left by the old embedded chart HTML (see chartdef_* / lastChartDefinitionId).
 * TEMPORARY: remove once no longer needed in the wild.
 */
export function clearLegacyChartDefinitionCookies(): void {
  if (typeof document === 'undefined') return

  const expires = ';expires=Thu, 01 Jan 1970 00:00:00 GMT'
  const host = globalThis.location.hostname
  const names = new Set<string>()

  for (const cookie of document.cookie.split(';')) {
    const trimmed = cookie.trim()
    if (!trimmed) continue
    const eqPos = trimmed.indexOf('=')
    const name = eqPos > -1 ? trimmed.substring(0, eqPos).trim() : trimmed.trim()
    if (isLegacyChartDefinitionCookieName(name)) names.add(name)
  }

  for (const name of names) {
    document.cookie = `${name}=${expires};path=/`
    document.cookie = `${name}=${expires};domain=${host};path=/`
  }
}

/**
 * Clean all cookies from the current domain and path
 */
export const clearAllCookies = (): void => {
  const cookies = document.cookie.split(';')

  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim()

    const expires = ';expires=Thu, 01 Jan 1970 00:00:00 GMT'

    // Delete cookie for the current path
    document.cookie = `${name}=${expires};path=/`

    // Delete cookie for root domain
    document.cookie = `${name}=${expires};domain=${globalThis.location.hostname};path=/`
  }
}
